import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Anonymous funnel step counting: a random per-browser id, no names, emails or athlete details.
export function track(event, page = "") {
  try {
    let anon = localStorage.getItem("rl_anon");
    if (!anon) { anon = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("rl_anon", anon); }
    axios.post(`${API}/track`, { event, page, anon }).catch(() => {});
  } catch { /* tracking must never break the page */ }
}
